/**
 * 비밀번호 유효성 검사 함수
 * @param {string} password - 검사할 비밀번호
 * @returns {Object} 유효성 검사 결과 객체 {isValid, errorType, message}
 */
export function validatePassword(password) {
  const minLength = 8;
  const categories = [
    /[A-Z]/, // 대문자
    /[a-z]/, // 소문자
    /\d/,    // 숫자
    /[^A-Za-z0-9]/ // 특수문자
  ];
  
  if (!password || password.length < minLength) {
    return { 
      isValid: false, 
      errorType: 'LENGTH', 
      message: '비밀번호는 최소 8자 이상이어야 합니다' 
    };
  }
  
  let count = 0;
  categories.forEach((regex) => {
    if (regex.test(password)) count++;
  });
  
  if (count < 3) {
    return { 
      isValid: false, 
      errorType: 'COMBINATION', 
      message: '비밀번호는 대문자, 소문자, 숫자, 특수문자 중 3가지 이상을 포함해야 합니다' 
    };
  }
  
  return { isValid: true };
}

/**
 * 비밀번호 확인 일치 여부 검사
 * @param {string} password - 비밀번호
 * @param {string} confirmPassword - 확인 비밀번호
 * @returns {Object} 일치 여부 검사 결과
 */
export function validatePasswordMatch(password, confirmPassword) {
  if (password !== confirmPassword) {
    return { 
      isMatch: false, 
      message: '비밀번호가 일치하지 않습니다' 
    };
  }
  return { isMatch: true };
}
